import { render, staticRenderFns } from "./SessionObjectCardHangman.vue?vue&type=template&id=42bcab09&scoped=true&"
import script from "./SessionObjectCardHangman.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCardHangman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bcab09",
  null
  
)

export default component.exports